import { memo } from 'react'

export const FOOTER_PORTAL_DIV_ID = 'taurine-footer-portal'

export const FooterPortalContainer = memo(() => (
  <div id={FOOTER_PORTAL_DIV_ID} />
))

FooterPortalContainer.displayName = 'FooterPortal'
